import React from "react";
import { FaFacebookF, FaInstagram, FaTiktok, FaWhatsapp } from 'react-icons/fa';

const facebookLink = "https://www.facebook.com/people/Venditek/61568728091418/?mibextid=ZbWKwL";
const instagramLink = "https://www.instagram.com/grupovenditek?igsh=MWJ1eWdmdjZ0Z29mcQ==";
const tiktokLink = "https://www.tiktok.com/@venditek?_t=ZM-8slT82wJy3J&_r=1";
const whatsappLink = "https://wa.me/50256302788";

export const Contact = () => {
  return ( 
    <div>
      <div id="contact" style={{ background: "linear-gradient(135deg, #FF7E5F, #FEB47B)", color: "#fff", padding: "50px 0" }}>
        <div className="container text-center">
          <h2 style={{ fontSize: "36px", fontWeight: "bold", marginBottom: "20px" }}>¡Contáctanos!</h2>
          <p style={{ fontSize: "18px", marginBottom: "-50px" }}>
            Estamos aquí para ayudarte. Escríbenos o visita nuestras redes sociales.
          </p>
          <div className="contact-info">
            <div className="contact-item" style={{ marginBottom: "20px" }}>
              <h3 style={{ fontSize: "24px", marginBottom: "10px" }}> </h3>
              <p style={{ fontSize: "16px" }}>
                <span style={{ display: "block", marginBottom: "5px" }}>
                  <i className="fa fa-map-marker"></i> Dirección: Km 9 CAES, complejo Vista Real (Hotel Hilton), Bodegas ALADO #18 y 19
                </span>
                <span style={{ display: "block", marginBottom: "5px" }}>
                  <i className="fa fa-phone"></i> Teléfono: (502) 5630 2788
                </span>
                <span style={{ display: "block" }}>
                  <i className="fa fa-envelope-o"></i> Correo Electrónico: info@grupovenditek.com
                </span>
              </p>
            </div>
          </div>
          <div className="social">
            <ul style={{ listStyleType: "none", padding: "0", display: "flex", justifyContent: "center", gap: "20px" }}>
              <li>
                <a href={facebookLink} target="_blank" rel="noopener noreferrer" style={{ color: "#fff", fontSize: "32px" }}>
                  <FaFacebookF />
                </a>
              </li>
              <li>
                <a href={instagramLink} target="_blank" rel="noopener noreferrer" style={{ color: "#fff", fontSize: "32px" }}>
                  <FaInstagram />
                </a>
              </li>
              <li>
                <a href={tiktokLink} target="_blank" rel="noopener noreferrer" style={{ color: "#fff", fontSize: "32px" }}>
                  <FaTiktok />
                </a>
              </li>
              <li>
                <a href={whatsappLink} target="_blank" rel="noopener noreferrer" style={{ color: "#fff", fontSize: "32px" }}>
                  <FaWhatsapp />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div id="footer" style={{ background: "#222", color: "#fff", padding: "10px 0", textAlign: "center" }}>
        <p>&copy; 2025 Venditek.</p>
      </div>
    </div>
  );
};
